import { DocumentTypeContractTypeEnum } from "stores";

export function categoryContractTypeToAdminRootEndpoint(contractType: DocumentTypeContractTypeEnum) {
    switch (contractType) {
        case DocumentTypeContractTypeEnum.PURCHASE: return '/admin/purchasecategories';
        case DocumentTypeContractTypeEnum.SALES: return '/admin/salescategories';
        case DocumentTypeContractTypeEnum.SERVICE: return '/admin/servicecategories';
        default: return '/admin';
    }
}